import H3 from 'components/H3';
import React from 'react';
import styled from 'styled-components';
import Chevron from './Chevron';

const Button = styled.button`
    padding: 20px 0px;
    background: transparent;
    border: 0px;
    &:focus {
        outline: 0;
    }
`

const Img = styled.img`
    width: 25px;
    height: 25px;
    margin-right: 12px;
`

const ButtonDropdown = (props) => {
    const { title, svg, active, onClick } = props;
    return (
        <Button onClick={onClick} className="col-12 d-flex flex-row align-items-center justify-content-between">
            <div className="d-flex flex-row align-items-center">
                <Img src={svg} />
                <H3>{title}</H3>
            </div>
            <Chevron active={active} />
        </Button>
    )
}

export default ButtonDropdown;